import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_LOAN_SUMMARY_START,
} from '../../actions/types'

import {
  updateLoanSummarySuccess,
  updateLoanSummaryFailure,
} from '../../actions'

import {
  getLoanApplicationId,
   } from '../../reducers'

import { putLoanApplicationUser } from '../../requesters/loanApplicationUser'

function* loanUpdateLoanSummary({payload}) {

  let data = {
    loan_application_user: {
      loan_summary_reviewed: payload.loanSummaryReviewed
    }
  }

  const loanApplicationId = yield select(getLoanApplicationId);
  const { response, error } = yield call(putLoanApplicationUser, loanApplicationId, data)

  if (response) {
    yield put(updateLoanSummarySuccess(response))
  } else {
    yield put(updateLoanSummaryFailure(error.response.data.errors))
  }
}

export function* watchLoanUpdateLoanSummary() {
  yield takeLatest(UPDATE_LOAN_SUMMARY_START, loanUpdateLoanSummary);
}
